import script from "./LayoutContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutContainer.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./LayoutContainer.vue?vue&type=style&index=1&id=5753b5fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5753b5fd"]])

export default __exports__